var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-list"},[_c('div',{staticClass:"row"},_vm._l((_vm.documents),function(document){return _c('document-teaser',{key:document,attrs:{"id":document,"col-class":_vm.colClass,"show-category":_vm.showCategory}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }